<template>
	<div class="brand-card" @click="$emit('click', manufacturer)">
		<div class="brand-image">
			<img :src="manufacturer.image" :alt="manufacturer.title" />
		</div>
		<div class="brand-content">
			<h4 class="brand-title">{{ manufacturer.title }}</h4>
			<div class="brand-divider"></div>
			<div v-if="manufacturer.categories.length" class="brand-categories">
				{{ categoryNames }}
			</div>
			<div class="brand-divider"></div>
			<p v-if="manufacturer.excerpt" class="brand-excerpt">{{ manufacturer.excerpt }}</p>

			<button type="button" class="brand-url" @click.stop="$emit('click', manufacturer)">
				Learn More
			</button>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';

export default {
	name: 'ManufacturerCard',
	props: {
		manufacturer: {
			type: Object,
			required: true,
		},
	},
	emits: ['click'],
	setup(props) {
		const categoryNames = computed(() => {
			return props.manufacturer.categories.join(', ');
		});

		return { categoryNames };
	},
};
</script>
